/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type TagEntity, tagSchema } from '@axiom/domain';
import { TagType } from '../../../enums/generated/tag-type';

export const eSTagDAOSchema = tagSchema.pick({ "id": true, "name": true }).extend({ "type": z.nativeEnum(TagType).nullish() });
export type ESTagDAO = Pick<TagEntity, "id" | "name"> & z.infer<typeof eSTagDAOSchema>;
